export default __webpack_public_path__ + "static/media/3044.bc7891a7.jpg";